export const currencyFormatter = new Intl.NumberFormat(undefined, {
    currency: "nok",
    style: "currency",
    minimumFractionDigits: 0
})